import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import Pagination from 'react-ultimate-pagination-bootstrap-4';

import './styles/MyReviewsContactListNav.scss';

const MyReviewsContactListNav = ({
  page,
  totalPages,
  reviewComplete,
  setPage,
  onClickAssigned,
  onClickCompleted
}) => (
  <div className='review-contact-list__navigation-row'>
    <ul className='review-contact-list__navigation triangle-breadcrumb'>
      <li className={!reviewComplete ? 'triangle-breadcrumb-selected' : ''}>
        <Button
          variant='link'
          href=''
          onClick={onClickAssigned}
        >
          My Assigned Reviews
        </Button>
      </li>
      <li className={reviewComplete ? 'triangle-breadcrumb-selected' : ''}>
        <Button
          variant='link'
          href=''
          onClick={onClickCompleted}
        >
          My Completed Reviews
        </Button>
      </li>
    </ul>
    {totalPages > 1 && (
      <Pagination
        currentPage={page}
        totalPages={totalPages}
        hideFirstAndLastPageLinks
        onChange={(newPage) => {
          setPage(newPage);
        }}
      />
    )}
  </div>
);

MyReviewsContactListNav.propTypes = {
  /** current page */
  page: PropTypes.number.isRequired,

  /** Total Pages for pagination */
  totalPages: PropTypes.number.isRequired,

  /** Review Complete flag */
  reviewComplete: PropTypes.bool,

  /** onClickAssigned callback function */
  onClickAssigned: PropTypes.func,

  /** onClickCompleted callback function */
  onClickCompleted: PropTypes.func,

  /** set Current page */
  setPage: PropTypes.func.isRequired
};

MyReviewsContactListNav.defaultProps = {
  reviewComplete: false,
  onClickAssigned: () => false,
  onClickCompleted: () => false
};

export default MyReviewsContactListNav;
